/**
 * Assert is failed
 */
export class AssertionError extends Error {
	constructor(message?: string) {
		super(message)
		this.name = 'Assertion error'
	}
}
